export const TableCellId = {
  FULL_NAME: 'fullName',
  PARTY: 'party',
  E_CONSENT: 'eConsent',
  CREDIT_CONSENT: 'creditConsent',
};

export const tableCellWidthMap = {
  [TableCellId.FULL_NAME]: '25%',
  [TableCellId.PARTY]: '25%',
  [TableCellId.E_CONSENT]: '25%',
  [TableCellId.CREDIT_CONSENT]: '25%',
};
